import {useState} from "react";
import {Button} from "../basic/button";
import {Collapsible, CollapsibleContent, CollapsibleTrigger} from "../basic/collapsible";
import {ChevronDown} from "lucide-react";
import {cn} from "../../utils/utils";

export interface CollapsibleSectionProps {
    title: string;
    icon?: React.ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    defaultOpen?: boolean;
    className?: string;
    children: React.ReactNode;
}

export function CollapsibleSection({
                                       title,
                                       icon,
                                       open: controlledOpen,
                                       onOpenChange,
                                       defaultOpen = false,
                                       className,
                                       children
                                   }: CollapsibleSectionProps) {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const isControlled = controlledOpen !== undefined;
    const isOpen = isControlled ? controlledOpen : internalOpen;

    const handleOpenChange = (newOpen: boolean) => {
        if (!isControlled) {
            setInternalOpen(newOpen);
        }
        onOpenChange?.(newOpen);
    };

    return (
        <Collapsible open={isOpen} onOpenChange={handleOpenChange} className={cn("pt-4", className)}>
            <div className={cn(
                "rounded-lg",
                isOpen ? "border" : "border-transparent"
            )}>
                <CollapsibleTrigger asChild>
                    <Button variant="ghost" className="w-full justify-between">
                        <div className="flex items-center gap-3">
                            {icon}
                            <span>{title}</span>
                        </div>
                        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}/>
                    </Button>
                </CollapsibleTrigger>
                <CollapsibleContent className="space-y-4 px-4 pt-4 pb-4">
                    {children}
                </CollapsibleContent>
            </div>
        </Collapsible>
    );
}
